import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  MASS_NOTIFICATION,
  massNotificationUrl,
} from 'SharedDir/backend/endpoints/mass-notification';
import { CopyFormType } from 'SharedDir/declarations/copy';
import {
  MassNotificationBare,
  MassNotificationCreate,
  MassNotificationFull,
  MassNotificationUpdate,
  MassNotificationUsersUpdate,
} from 'SharedDir/declarations/mass-notification';

export class MassNotificationApiClass extends SimpleApi<
  MassNotificationFull,
  MassNotificationCreate,
  MassNotificationUpdate,
  MassNotificationBare
> {
  constructor() {
    super(massNotificationUrl);
  }

  protected readonly endpoints = MASS_NOTIFICATION;

  /**
   * Копировать рассылку
   * @param data
   * @returns
   */
  public async copy(data: CopyFormType) {
    const endpoint = this.endpoints.COPY(data.id);
    console.log('copy');
    const { data: responseData } = (await http({
      ...endpoint,
      data,
    })) as AxiosResponse<MassNotificationFull>;

    return responseData;
  }

  /**
   * Изменение получателей рассылку
   * @param data
   * @param id
   * @returns
   */
  public async usersUpdate(id: number, data: MassNotificationUsersUpdate) {
    const endpoint = this.endpoints.UPDATE_USERS(id);
    const { data: responseData } = (await http({
      ...endpoint,
      data,
    })) as AxiosResponse<MassNotificationFull>;

    return responseData;
  }

  /**
   * Активировать рассылку
   * @param id
   * @returns
   */
  public async send(id: number) {
    const endpoint = this.endpoints.SEND(id);
    const { data: responseData } = (await http({
      ...endpoint,
    })) as AxiosResponse<MassNotificationFull>;

    return responseData;
  }
}
